var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-search',{attrs:{"get-messages":_vm.getMessages,"delete-message":_vm.deleteMessage,"get-applications":_vm.getApplications,"get-roles":_vm.getRoles,"get-locations":_vm.getLocations,"download-file":_vm.downloadFile,"default-role":_vm.userProfile.roleId,"default-application":_vm.appId,"add-and-filter-persmission":_vm.canManageMessages}})
}
var staticRenderFns = []

export { render, staticRenderFns }